<template>
    <div class="home md:max-w-sm w-full p-4">
        <div class="text-center w-full">
            <spinner :display="isLoading" spinner-class="block" />
        </div>
        <template v-if="!isLoading && errors.length <= 0 && caseDefaultData && !forceRefresh">
            <div class="p-6 bg-white rounded-lg border border-gray-200 shadow-md mb-4">
                <h1 class="text-2xl font-extrabold">{{caseDefaultData.marque}}</h1>
                <h1 class="text-md font-light">Référence: {{caseDefaultData.ref_case}}</h1>
                <h1 class="text-md font-light">Modèle: {{caseDefaultData.modele}}</h1>
            </div>
            <div v-show="step == 0" v-for="(category, indexCateg) in categories" v-bind:key="'category-' + indexCateg">
                <div class="p-6 bg-white rounded-lg border border-gray-200 shadow-md mb-4">
                    <h2 class="text-xl">{{category.title}}</h2>
                    <div v-for="(child, indexChild) in category.childs" v-bind:key="'child-' + indexChild">
                        <div class="mt-4" :class="child.class" v-if="!child.hide">
                            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400" v-if="child.label && child.type != 'checkbox'" :for="'input-' + indexChild">{{child.label}}</label>
                            <template v-if="child.type == 'select'">
                                <select
                                :id="'input-' + indexChild"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                :class="child.errors.length > 0 ? 'border-rose-800 text-rose-800 font-bold' : 'border-gray-300 text-gray-900'"
                                v-model="child.result"
                                @change="child.onChange ? textToScript(child.onChange) : ''"
                                >
                                    <option v-model="child.result" value=""></option>
                                    <option
                                    v-for="(selectValue, indexSelectValue) in child.values"
                                    :v-bind:key="'select-value-' + indexChild + '-' + indexSelectValue"
                                    :value="selectValue.value"
                                    >
                                        {{selectValue.label}}
                                    </option>
                                </select>
                            </template>
                            <template v-else-if="child.type == 'textarea'">
                                <textarea
                                v-model="child.result"
                                rows="5"
                                :placeholder="child.placeholder"
                                class="block p-2.5 w-full text-sm bg-gray-50 rounded-lg border focus:ring-blue-500 focus:border-blue-500"
                                :class="child.errors.length > 0 ? 'border-rose-800 text-rose-800 font-bold' : 'border-gray-300 text-gray-900'"
                                ></textarea>
                            </template>
                            <template v-else-if="child.type == 'text'">
                                <input
                                v-model="child.result"
                                type="text"
                                class="block p-2.5 w-full text-sm bg-gray-50 rounded-lg border focus:ring-blue-500 focus:border-blue-500"
                                :class="child.errors.length > 0 ? 'border-rose-800 text-rose-800 font-bold' : 'border-gray-300 text-gray-900'"
                                :placeholder="child.placeholder"
                                >
                            </template>
                            <template v-else-if="child.type == 'datetime'">
                                <input
                                v-model="child.result"
                                type="datetime-local"
                                class="block p-2.5 w-full text-sm bg-gray-50 rounded-lg border focus:ring-blue-500 focus:border-blue-500"
                                :class="child.errors.length > 0 ? 'border-rose-800 text-rose-800 font-bold' : 'border-gray-300 text-gray-900'"
                                >
                            </template>
                            <template v-else-if="child.type == 'draw'">
                                <draw-input
                                class="mx-auto mt-2"
                                :btn-class="child.errors.length > 0 ? 'background-rose-800 text-rose-800 font-bold' : ''"
                                modal-string="Test"
                                :background="child.background"
                                :meta="{child: child}"
                                @submit="callbackDrawImage"
                                />
                            </template>
                            <template v-else-if="child.type == 'checkbox'">
                                <div class="text-left">
                                    <input class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 mr-2" v-model="child.result" :value="child.value" :id="'checkbox-' + indexChild" type="checkbox">
                                    <label :for="'checkbox-' + indexChild">{{child.label}}</label>
                                </div>
                            </template>
                            <template v-else-if="child.type == 'checkboxs'">
                                <div
                                v-for="(checkbox, indexCheckbox) in child.values"
                                v-bind:key="'checkbox-' + indexChild + '-' + indexCheckbox"
                                class="text-left"
                                >
                                    <input
                                    class="w-4 h-4 rounded mr-2"
                                    :class="child.errors.length > 0 ? 'border-rose-800' : 'border-gray-300 text-gray-900'"
                                    v-model="child.result"
                                    :value="checkbox.value"
                                    :id="'checkbox-' + indexChild + '-' + indexCheckbox + '-' + child.valueKeyname"
                                    type="checkbox"
                                    >
                                    <label :for="'checkbox-' + indexChild + '-' + indexCheckbox + '-' + child.valueKeyname">{{checkbox.label}}</label>
                                    <hr v-if="indexCheckbox + 1 < child.values.length" class="my-3">
                                </div>
                            </template>
                            <template v-else>
                                <div>
                                    <small>
                                        Erreur: Le type n'est pas bien configuré pour {{child.label}}.<br />
                                        Contacter l'administrateur.
                                    </small>
                                </div>
                            </template>
                        </div>
                        <div
                        v-for="(error, indexError) in child.errors"
                        v-bind:key="'error-' + indexError + '-child-'+ indexChild"
                        class="mt-3"
                        >
                            <span class="text-rose-800" v-html="error"></span>
                        </div>
                    </div>

                </div>
            </div>
            <button @click="goToNextPage" class="text-white bg-green-600 hover:bg-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center" type="button">
                Continuer
            </button>
        </template>
        <template v-if="errors">
            <div v-bind:key="'error-' + errorIndex" v-for="(error, errorIndex) in errors">
                <div v-html="error"></div>
            </div>
        </template>
    </div>
</template>

<script>
import DrawInput from '@/components/DrawInput.vue'
import Spinner from '@/components/Spinner.vue'

import ImageConversionTool from '@/tools/ImageConversionTool'

import ApiService from '@/services/api.service.js'

export default {
    name: 'Home',

    components: {
        DrawInput,
        Spinner
    },

    data() {
        return {
            step: 0,
            categories: [],
            technicians: [],
            isLoading: false,
            errors: [],
            forceRefresh: false,
            requestLoading: false,
            caseDefaultData: null,
        }
    },

    methods: {
        textToScript(text) {
            return eval(text)
        },

        /*--------------
            Set data
        --------------*/

        async getData() {
            this.isLoading = true

            let response = await ApiService.get('getcase', {id_case: this.$route.params.id})
            if (!response.data.posts.post) {
                this.$router.push('/')
            } else {
                this.caseDefaultData = response.data.posts.post
                this.technicians = response.data.posts.post.tech
                let keynameFormSpace = response.data.posts.post.categ
                try {
                    let FormConfig = require('@/config/forms/' + keynameFormSpace.toLowerCase() +'/form.js').default
                    if (Array.isArray(FormConfig)) {
                        this.categories = FormConfig

                        this.addResultInCategory()
                        this.addErrorsInCategory()
                        localStorage.setItem('case_id', this.$route.params.id)
                    }
                } catch (ex) {
                    this.errors.push("<b class='text-lg'>Le formulaire n'a pas pu charger correctement</b><br />Contacter l'administrateur")
                    console.error(keynameFormSpace + " can't load configuration form file");
                }

                localStorage.setItem('form-mobi-default-data', JSON.stringify(this.caseDefaultData))


                this.isLoading = false
            }
        },

        getChildByValueKeyname(keyname) {
            let child = null
            this.categories.forEach((category, indexCateg) => {
                if (category.childs) {
                    category.childs.forEach((childCategory, indexChild) => {
                        if (childCategory.valueKeyname && childCategory.valueKeyname == keyname) {
                            child = childCategory
                        }
                    })
                }
            })
            return child
        },

        loadLocalStorage() {
            if (localStorage['form-mobi']) {
                let data = JSON.parse(localStorage['form-mobi'])
                for (var index in data) {
                    let child = this.getChildByValueKeyname(index)
                    if (child) {
                        if (child.type != 'checkboxs') {
                            child.result = data[index]
                        }
                        if (child.type == 'checkboxs') {
                            for (var checkbox in data[index]) {
                                if (data[index][checkbox].coche == true) {
                                    child.result.push(checkbox)
                                }
                            }
                        }
                    }
                }
                this.forceRefresh = true
                this.$nextTick(() => {
                    this.forceRefresh = false
                })
            }
        },

        addResultInCategory() {
            this.categories.forEach((category, indexCateg) => {
                if (category.childs) {
                    category.childs.forEach((childCategory, indexChild) => {
                        if (childCategory.valueKeyname) {
                            if (childCategory.type == "checkboxs") {
                                this.categories[indexCateg].childs[indexChild].result = []
                            } else {
                                this.categories[indexCateg].childs[indexChild].result = null
                            }
                        }
                    })
                }
            })
        },

        addErrorsInCategory() {
            this.categories.forEach((category, indexCategory) => {
                category.childs.forEach((child, indexChild) => {
                    this.categories[indexCategory].childs[indexChild].errors = []
                })
            })
        },

        /*--------------
            Errors
        --------------*/

        hasErrors() {
            let errorFound = false
            this.categories.forEach((category, indexCategory) => {
                if (category.childs) {
                    category.childs.forEach((childCategory, indexChild) => {
                        if (childCategory.required === true && !childCategory.hide && (!childCategory.result || (childCategory.type == 'checkboxs' && childCategory.result.length <= 0))) {
                            this.categories[indexCategory].childs[indexChild].errors = ['Champ obligatoire']
                            errorFound = true
                        } else {
                            this.categories[indexCategory].childs[indexChild].errors = []
                        }
                    })
                }
            })

            if (!errorFound) {
                return false
            } else {
                this.$toast.error("Formulaire incomplet");
                this.forceRefresh = true
                this.$nextTick(() => {
                    this.forceRefresh = false
                })
            }
            return true
        },

        /*---------------------------------
            Get callback of drawing input
        ---------------------------------*/

        async callbackDrawImage(result) {
            let keyname = 'draw-' + result.meta.child.valueKeyname
            ImageConversionTool.storeImage(
                keyname,
                result.blob
            )
            result.meta.child.localstorage_keyname = keyname
        },

        /*-------------------
            Go to next page
        -------------------*/

        goToNextPage() {
            // Check errors
            if (this.hasErrors()) {
                return
            }

            // Init EndData
            let endData = {}

            // Parse data to ended object
            endData.id_case = this.$route.params.id
            this.categories.forEach((category) => {
                if (category.childs) {
                    category.childs.forEach((childCategory, indexChild) => {
                        // Parse end object
                        if (childCategory.valueKeyname) {
                            // Parse checkboxs
                            if (childCategory.type != 'checkboxs') {
                                endData[childCategory.valueKeyname] = childCategory.result
                            } else {
                                let endObj = {}
                                childCategory.values.forEach((item) => {
                                    let isChecked = childCategory.result.find((val) => val == item.value)
                                    endObj[item.value] = {
                                        label: item.label,
                                        name: item.value,
                                        coche: isChecked ? true : false
                                    }
                                })
                                endData[childCategory.valueKeyname] = endObj
                            }
                        }
                    })
                }
            })
            
            localStorage.setItem('form-mobi', JSON.stringify(endData))

            this.$router.push({name: 'validation'})
        }
    },

    async mounted() {
        await this.getData()
        this.loadLocalStorage()
    }
}
</script>
